import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { viewEnginePiletOverlays } from '@sharefiledev/view-engine-pilet-sdk';
import { ViewByContainerRIDDialog } from './ViewByContainerRIDDialog';
import { ViewByContainerRIDDrawer } from './ViewByContainerRIDDrawer';
import { ViewByRIDDialog } from './ViewByRIDDialog';
import { ViewByRIDDrawer } from './ViewByRIDDrawer';

export function addOverlays(piral: PiletApi) {
	piral.registerDrawer(
		viewEnginePiletOverlays.viewByRIDDrawer,
		props => {
			return <ViewByRIDDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '500px',
			},
		}
	);
	piral.registerDrawer(
		viewEnginePiletOverlays.viewByContainerRIDDrawer,
		props => {
			return <ViewByContainerRIDDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '500px',
			},
		}
	);
	piral.registerModal(
		viewEnginePiletOverlays.viewByRIDDialog,
		props => {
			return <ViewByRIDDialog {...props} />;
		},
		{
			modalProps: {},
		}
	);
	piral.registerModal(
		viewEnginePiletOverlays.viewByContainerRIDDialog,
		props => {
			return <ViewByContainerRIDDialog {...props} />;
		},
		{
			modalProps: {},
		}
	);
}
